import { render } from "./InfoContainer.vue?vue&type=template&id=5293ec5f&scoped=true"
import script from "./InfoContainer.vue?vue&type=script&lang=js"
export * from "./InfoContainer.vue?vue&type=script&lang=js"

import "./InfoContainer.vue?vue&type=style&index=0&id=5293ec5f&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5293ec5f"]])

export default __exports__